module.exports = /*#__PURE__*/JSON.parse('{"rE":"1.23.6","Al":"/docs/","mp":"/docs/guide/feedback"}')